import type { LoginTranslations } from "../interfaces/login";

export const loginTranslations: LoginTranslations = {
  title: "Move your money",
  title_emphasis: "in seconds.",
  subtitle:
    "Coloca is the technology that lets you {emphasis} across Latin America. Send and collect like a local, without the high costs and delays of SWIFT.",
  subtitle_emphasis: "send and receive money",
  google_button: "Sign in with Google",
  login_button: "Log in",
  input_user_label: "Email",
  input_user_placeholder: "Enter your email",
  input_password_label: "Password",
  input_password_placeholder: "Enter your password",
  checkbox_remember_me: "Remember me",
  login_account_label_prefix: "Already have an account?",
  login_account_label_button: "Log in",
  terms_and_conditions: "Terms and conditions",
  // 2FA translations
  twofa_title: "Two-step verification",
  twofa_subtitle: "Enter the 6-digit code from your authenticator app",
  twofa_authenticator_hint: "Open your authenticator app (Google Authenticator, Authy, etc.)",
  twofa_digits_counter: "{count}/6 digits entered",
  twofa_verify_button: "Verify code",
  twofa_verifying_button: "Verifying...",
  twofa_back_link: "Back to login",
  twofa_support_text: "Don't have access to your authenticator app?",
  twofa_support_link: "Contact support",
  // Change Password translations
  change_password_title: "Change Password",
  change_password_subtitle: "Please enter your current password and a new password.",
  current_password_label: "Current Password",
  current_password_placeholder: "Enter current password",
  new_password_label: "New Password",
  new_password_placeholder: "Enter new password",
  confirm_password_label: "Confirm New Password",
  confirm_password_placeholder: "Confirm new password",
  change_password_button: "Change Password",
  back_button: "Back",
  input_error_same_password: "New password cannot be the same as current password",
  input_error_passwords_must_match: "Passwords must match",
  // Forgot password flow
  forgot_password_link: "Forgot your password?",
  fp_step_request: "Request",
  fp_step_verify: "Verify",
  fp_step_new: "New password",
  fp_step_done: "Done",
  fp_request_title: "Recover your password",
  fp_request_subtitle:
    "Enter the email on your account and we will send you a secure link to create a new password.",
  fp_request_email_label: "Email",
  fp_request_email_placeholder: "you@company.com",
  fp_request_hint: "We will send a link valid for 1 hour.",
  fp_request_submit: "Send recovery link",
  fp_request_back: "Back to login",
  fp_verify_title: "Check your email",
  fp_verify_subtitle:
    "We sent a recovery link to {email}. Click the button in the email or enter the code below.",
  fp_verify_code_label: "Verification code",
  fp_verify_code_hint: "The code has 6 digits and expires in 1 hour.",
  fp_verify_submit: "Verify code",
  fp_verify_resend: "Didn't get it?",
  fp_verify_resend_cooldown: "Resend in {seconds}s",
  fp_verify_change_email: "Change email",
  fp_new_title: "Create a new password",
  fp_new_subtitle: "Verified for {email}. Choose a password you have not used before.",
  fp_new_password_label: "New password",
  fp_new_password_placeholder: "At least 8 characters",
  fp_new_confirm_label: "Confirm password",
  fp_new_confirm_placeholder: "Repeat the password",
  fp_new_submit: "Reset password",
  fp_new_strength: "Strength",
  fp_new_strength_empty: "Very weak",
  fp_new_strength_weak: "Weak",
  fp_new_strength_fair: "Fair",
  fp_new_strength_good: "Good",
  fp_new_strength_strong: "Strong",
  fp_new_req_length: "At least 8 characters",
  fp_new_req_number: "A number",
  fp_new_req_symbol: "A special symbol (!@#$...)",
  fp_new_req_long: "12 characters or more (recommended)",
  fp_new_match_ok: "Match",
  fp_new_match_error: "Passwords do not match.",
  fp_done_title: "Password updated",
  fp_done_subtitle: "Your password was successfully changed. You can now sign in with your new credentials.",
  fp_done_go_login: "Go to sign in",
  fp_error_invalid_code: "Invalid or expired code.",
  fp_error_expired: "The link has expired. Please request a new one.",
  fp_error_weak_password: "Password does not meet the minimum requirements.",
  fp_error_network: "We could not complete the request. Check your connection and try again.",

  // Accept invitation
  inv_verifying_aria: "Verifying the invitation",
  inv_eyebrow: "Invitation",
  inv_title: "You've been invited to join {org}",
  inv_email_label: "Invitation for",
  inv_name_label: "Full name",
  inv_name_placeholder: "First and last name",
  inv_name_required: "Enter your full name to accept the invitation.",
  inv_name_max: "Maximum 255 characters.",
  inv_password_label: "Create a password",
  inv_password_placeholder: "••••••••",
  inv_password_max: "Maximum 128 characters.",
  inv_confirm_label: "Confirm your password",
  inv_confirm_placeholder: "••••••••",
  inv_submit: "Join {org}",
  inv_expiry_note: "This link is single-use and expires on {date}.",
  inv_footer_ignore: "Wrong account or unexpected invitation? You can ignore this email.",
  inv_session_notice: "You are signed in as {current}. This invitation is for {invited}.",
  inv_session_continue: "Continue and switch account",
  inv_throttled: "Too many attempts — wait a minute and try again.",
  inv_invalid_title: "This invitation link is no longer valid",
  inv_invalid_body:
    "It may have expired or already been used. Ask the person who invited you to send a new invitation.",
  inv_go_login: "Go to sign in",
  inv_error_title: "We couldn't verify the invitation",
  inv_error_body: "There was a connection problem while validating the link. Try again in a moment.",
  inv_retry: "Retry",
  inv_conflict_title: "An account with this email already exists",
  inv_conflict_body: "The invitation for {email} belongs to an account already registered in Coloca.",
  inv_conflict_login: "Sign in",
  inv_success_title: "Welcome to {org}",
  inv_success_entering: "Taking you to your dashboard…",
};
